<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mpafVQ/media/FC-9798886935202.jpg?1718046581364" alt="This image is the cover for the book The Panterra Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Panterra Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p>Growing up as SuperTramp aerialists on the Cirque du Panterra family’s sprawling sheep station in Outback, Australia, is an amazing adventure filled with wonder and magic. </p><p><br/></p><p>Following the destruction of habitat from raging bushfires, Xtarla and Rick Panterra join in the search and rescue of injured wildlife. While sheltering in an abandoned opal mine from a hot spot flare-up, the team discovers injured koalas, which are transported to a field hospital and wildlife sanctuary, where they are found to be mutants. From there, the koalas are transferred to the family’s Panterra Xtar Rancho Habitat and Wildlife Sanctuary outside of Las Vegas for protection and further study.</p><p><br/></p><p>The Panterra SuperTramps accompany the koalas as their handlers and begin to discover burgeoning superpowers along with uncanny code-cracking skills. Once they break into the storage vaults contained in the labyrinth underneath the old MobXtar Grand Marquis Hotel and Resort, their odyssey begins as they time-slip into parallel dimensions and they discover dual credentials into the galaxy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Punch Barrett
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'><span style="font-size:15px;">Patricia Punch Barrett is a retired elementary school teacher living in Henderson, Nevada.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00870864